import { Component, Input } from '@angular/core';

@Component({
    selector: 'cas-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {

    @Input() public message: string;

}
